import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import dayjs from "dayjs";
import DateAdapter from "../../../adapters/DateAdapter";

export default class GetPaymentReminderPreviewResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "message": "Hola, te recordamos que tenés facturas vencidas pendientes de pago. Te pedimos que regularices la situación a la brevedad.",
                "subject": "Recordatorio de pago — Client123BN123",
                "receivers": ["cobranzas@dundermifflin.com"],
                "blind_copy_receivers": ["kam@dundermifflin.com", "cobranzas2@dundermifflin.com"],
                "overdue_invoices": [{
                    "number": "12345-123456",
                    "expiration_date": "2026-09-16",
                    "days_overdue": 8,
                    "total": {"amount": 1500.00, "currency": "ARS"},
                    "pending_balance": {"amount": 1000.00, "currency": "ARS"},
                    "reminder_history": {
                        "has_reminders": true,
                        "count": 2,
                        "first_reminder_sent_at": "2026-09-20T14:30:00-03:00",
                        "last_reminder_sent_at": "2026-09-27T10:15:00-03:00"
                    }
                }, {
                    "number": "12345-123457",
                    "expiration_date": "2026-09-10",
                    "days_overdue": 14,
                    "total": {"amount": 800.00, "currency": "ARS"},
                    "pending_balance": {"amount": 800.00, "currency": "ARS"},
                    "reminder_history": {
                        "has_reminders": false,
                        "count": 0,
                        "first_reminder_sent_at": null,
                        "last_reminder_sent_at": null
                    }
                }],
                "total_overdue": {"amount": 1800.00, "currency": "ARS"},
                "payment_track_record": {
                    "customer_since": "2025-03-12",
                    "paid_invoices": 14,
                    "late_paid_invoices": 3,
                    "upcoming_invoices": 2
                }
            },
            errors: []
        }
    }

    message() {
        return this.content().message;
    }

    subject() {
        return this.content().subject;
    }

    receivers() {
        return this.content().receivers;
    }

    blindCopyReceivers() {
        return this.content().blind_copy_receivers;
    }

    overdueInvoices() {
        return this.content().overdue_invoices.map(overdueInvoice => ({
            number: overdueInvoice.number,
            expirationDate: this._adaptedDate(overdueInvoice.expiration_date),
            daysOverdue: overdueInvoice.days_overdue,
            total: overdueInvoice.total,
            pendingBalance: overdueInvoice.pending_balance,
            reminderHistory: {
                hasReminders: overdueInvoice.reminder_history.has_reminders,
                count: overdueInvoice.reminder_history.count,
                firstReminderSentAt: this._adaptedOptionalDate(overdueInvoice.reminder_history.first_reminder_sent_at),
                lastReminderSentAt: this._adaptedOptionalDate(overdueInvoice.reminder_history.last_reminder_sent_at),
            },
        }));
    }

    totalOverdue() {
        return this.content().total_overdue;
    }

    paymentTrackRecord() {
        const paymentTrackRecord = this.content().payment_track_record;
        return {
            customerSince: this._adaptedOptionalDate(paymentTrackRecord.customer_since),
            paidInvoices: paymentTrackRecord.paid_invoices,
            latePaidInvoices: paymentTrackRecord.late_paid_invoices,
            upcomingInvoices: paymentTrackRecord.upcoming_invoices,
        };
    }

    _adaptedDate(isoDate) {
        return new DateAdapter('DD/MM/YYYY').adapt(dayjs(isoDate));
    }

    _adaptedOptionalDate(isoDate) {
        return isoDate ? this._adaptedDate(isoDate) : null;
    }
}
